(function () {
  function mount(header) {
    if (!header || header.dataset.mountedHeader === "true") return;
    header.dataset.mountedHeader = "true";

    var toggle = header.querySelector("[data-ms-menu-toggle]");
    if (!toggle) return;

    toggle.addEventListener("click", function () {
      var isOpen = header.classList.toggle("is-menu-open");
      toggle.setAttribute("aria-expanded", String(isOpen));
      if (isOpen) header.classList.remove("is-hidden");
    });

    var lastY = window.scrollY || 0;
    var ticking = false;
    var threshold = 8;
    var revealTop = 24;

    function updateTopbarHeight() {
      var topbar = document.querySelector(".ms-announcement-bar");
      var height = topbar ? Math.round(topbar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty("--ms-topbar-height", height + "px");
    }

    function updateHeader() {
      updateTopbarHeight();
      var currentY = window.scrollY || 0;
      var delta = currentY - lastY;
      var menuOpen = header.classList.contains("is-menu-open");
      var navOpen = header.querySelector(".ms-nav-item.is-open");

      header.classList.toggle("is-scrolled", currentY > revealTop);

      if (!menuOpen && !navOpen && Math.abs(delta) > threshold) {
        if (delta > 0 && currentY > 120) {
          header.classList.add("is-hidden");
        } else {
          header.classList.remove("is-hidden");
        }
        lastY = currentY;
      } else if (currentY <= revealTop || menuOpen || navOpen) {
        header.classList.remove("is-hidden");
        lastY = currentY;
      }

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", updateTopbarHeight, { passive: true });
    updateHeader();

    Array.prototype.slice.call(header.querySelectorAll(".ms-nav-item")).forEach(function (item) {
      var closeTimer;

      function openItem() {
        if (window.innerWidth <= 760) return;
        window.clearTimeout(closeTimer);
        header.classList.remove("is-hidden");
        Array.prototype.slice.call(header.querySelectorAll(".ms-nav-item")).forEach(function (other) {
          if (other !== item) other.classList.remove("is-open");
        });
        item.classList.add("is-open");
      }

      function closeItem() {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          item.classList.remove("is-open");
        }, 180);
      }

      item.addEventListener("mouseenter", openItem);
      item.addEventListener("mouseleave", closeItem);
      item.addEventListener("focusin", openItem);
      item.addEventListener("focusout", closeItem);
    });
  }

  function mountAll() {
    document.querySelectorAll("[data-ms-header]").forEach(mount);
  }

  document.addEventListener("DOMContentLoaded", mountAll);
  document.addEventListener("shopify:section:load", function (event) {
    event.target.querySelectorAll("[data-ms-header]").forEach(mount);
    document.querySelectorAll("[data-ms-header]").forEach(function (header) {
      var topbar = document.querySelector(".ms-announcement-bar");
      document.documentElement.style.setProperty("--ms-topbar-height", (topbar ? Math.round(topbar.getBoundingClientRect().height) : 0) + "px");
      header.classList.remove("is-hidden");
    });
  });
  document.addEventListener("shopify:section:unload", function () {
    var topbar = document.querySelector(".ms-announcement-bar");
    document.documentElement.style.setProperty("--ms-topbar-height", (topbar ? Math.round(topbar.getBoundingClientRect().height) : 0) + "px");
  });
})();

(function () {
  if (window.msBagPopupReady) return;
  window.msBagPopupReady = true;
  const popup = document.createElement('dialog');
  popup.className = 'ms-bag-modal';
  popup.dataset.msBagModal = '';
  popup.dataset.cartUrl = (window.Shopify?.routes?.root || '/') + 'cart';
  popup.setAttribute('aria-label', 'Bag');
  const close = document.createElement('button');
  close.type = 'button';
  close.dataset.bagClose = '';
  close.setAttribute('aria-label', 'Close');
  close.textContent = '×';
  const content = document.createElement('div');
  content.dataset.bagContent = '';
  popup.append(close, content);
  document.body.append(popup);
  let opener;
  let previousOverflow;
  async function loadBag(dialog) {
    const response = await fetch(dialog.dataset.cartUrl, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Bag unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const section = doc.querySelector('[data-ms-cart-page]');
    if (!section) throw new Error('Bag unavailable');
    section.querySelectorAll('script').forEach(script => script.remove());
    dialog.querySelector('[data-bag-content]').replaceChildren(section);
  }
  document.addEventListener('click', async event => {
    const dialog = document.querySelector('[data-ms-bag-modal]');
    if (!dialog) return;
    if (event.target.closest('[data-bag-close]')) { dialog.close(); return; }
    const link = event.target.closest('a');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== dialog.dataset.cartUrl.replace(/\/$/, '')) return;
    event.preventDefault();
    opener = link;
    try {
      await loadBag(dialog);
      document.querySelectorAll('[data-ms-cart-panel]').forEach(panel => { panel.hidden = true; panel.classList.remove('is-visible'); });
      document.documentElement.classList.remove('ms-cart-panel-open');
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    } catch (_) { location.href = link.href; }
  });
  popup.addEventListener('change', async event => {
    const input = event.target.closest('[data-ms-cart-quantity-input]');
    if (!input) return;
    const form = input.closest('form');
    try {
      const response = await fetch(popup.dataset.cartUrl + '/update.js', { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
      if (!response.ok) throw new Error('Update failed');
      await loadBag(popup);
    } catch (_) { location.href = popup.dataset.cartUrl; }
  });
  popup.addEventListener('click', async event => {
    const remove = event.target.closest('.ms-cart-remove');
    if (!remove) return;
    event.preventDefault();
    try { await fetch(remove.href, { credentials: 'same-origin' }); await loadBag(popup); }
    catch (_) { location.href = popup.dataset.cartUrl; }
  });
  document.addEventListener('close', event => {
    if (!event.target.matches('[data-ms-bag-modal]')) return;
    document.documentElement.style.overflow = previousOverflow || '';
    opener?.focus();
  }, true);
  document.addEventListener('click', event => {
    const dialog = event.target.closest('[data-ms-bag-modal]');
    if (!dialog || event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
})();
